export function buildSecureLinkCustomHostname(
  customHostname: string | undefined,
  portNumber: number,
  uniqueSuffix: string,
): string {
  const hostname = customHostname?.trim() || String(portNumber);
  const normalizedSuffix = uniqueSuffix.trim().toLowerCase();
  if (!normalizedSuffix) return hostname;

  const hostnameSuffix = `-${normalizedSuffix}`;
  return hostname.endsWith(hostnameSuffix)
    ? hostname
    : `${hostname}${hostnameSuffix}`;
}
